import moment from 'moment';
import { Lead } from './types';

export const formatCurrency = (value: number): string => {
  return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
};

export const getPriority = (item: Lead): string | null => {
  if (item.additional_data && item.additional_data.priority) {
    return item.additional_data.priority.toLowerCase();
  }
  return null;
};

export const formatDate = (date: string): string => {
  return moment(date).fromNow();
};

export const hasCadences = (item: Lead): boolean => {
  return Boolean(item.additional_data && item.additional_data.cadences);
};

export const hasSource = (item: Lead): boolean => {
  return Boolean(item.additional_data && item.additional_data.source);
};

export const hasValue = (item: Lead): boolean => {
  return Boolean(item.value);
};

export const isApifyOrigin = (item: Lead): boolean => {
  return Boolean(
    item.additional_data && (
      item.additional_data.source === 'apify' ||
      item.additional_data.apify_integration_id
    )
  );
};
